export const MarketplacesAppsEndpoints = {
  getMarketplacesApps: 'getMarketplacesApps',
} as const;

export const MarketplacesAppsTags = {
  marketplacesApps: 'marketplacesApps',
} as const;
